import * as searchMenuItemsCoordinators from './search'

export default Object.freeze({
  ...searchMenuItemsCoordinators,
})
